// @flow
// $FlowFixMe
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

export default history



// WEBPACK FOOTER //
// ./src/config/history.js